module.exports = __webpack_public_path__ + "img/sel_online_radio.65dd3e19.svg";